import cn from 'classnames'

import styles from './styles.module.scss'
interface CustomButtonProps {
    onClick?: () => void
    textBtn: string
    classNames?: {
        textBtn?: string
    }
    disabled?: boolean
}
export const CustomButton = ({
    onClick,
    textBtn,
    classNames,
    disabled,
}: CustomButtonProps) => {
    return (
        <button
            className={cn(styles.button_outer, {
                [styles.button_outer_disabled]: disabled,
            })}
            onClick={onClick}
            disabled={disabled}
        >
            <div
                className={cn(styles.button_inner, {
                    [styles.button_inner_disabled]: disabled,
                })}
            >
                <span className={cn(styles.button_text, classNames?.textBtn)}>
                    {textBtn}
                </span>
            </div>
        </button>
    )
}
